<template>
  <div :value="value">
    <normalTable
      :tableData="tableData"
      ref="refNormalTable"
      @loadData="loadData"
      :changeInfo="true"
      @showInfo="showInfo"
      :showMyInfo="true"
      :typeUserData="typeUserData"
      @downLoad="downLoad"
      :deleteFlowId="0"
      :totalPage="totalPage"
      :delType="activeName=='first'?'0':'3'"
      :flowids="activeName=='first'?'0':'10'"
      :tableLoading='tableLoading'
    ></normalTable>
    <Pagination
      @onChange="getReportExamine"
      class="pagination"
      :total="totalPage"
      :pagination="pagination"
      style="text-align:right;margin:20px 0;"
    />
    <checkInfo ref="checkInfo" @loadDataNowPage="getReportExamine" :activeName="activeName"  @loadDataPage="loadData"></checkInfo>
  </div>
</template>
<script>
import Pagination from "components/pagination/pagination";
import normalTable from "views/CreditScore/common/normalTable";
import { fetchGet, fetchPost, fetchGetDown } from "@/libs/reqCommon";
import elementHint from "components/dataTable/elementHint"; //提示
import { mapMutations, mapActions, mapGetters, mapState } from "vuex";
import checkInfo from "./checkInfo";
import creditReport from "@/mixins/creditReport.js";

export default {
  props: {
    activeName: {
      type: String
    },
    value: {
      type: Number
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  mixins: [creditReport],

  data() {
    return {
      tableData: [],
      pagination: {
        size: 10,
        current: 1
      },
      totalPage: 10,
      deleteVisible: true,
      typeUserData: JSON.parse(window.localStorage.userData)
    };
  },
  components: { Pagination, normalTable, checkInfo },
  computed: {
    ...mapState({
      creditSearchData: state => state.creditScore.creditSearchData
    })
  },
  mounted() {
    this.getReportExamine();
    this.changeCompleteShow();
    this.changenormaltableLoading(true)
  },
  methods: {
    ...mapMutations(["changeCompleteShow",'changenormaltableLoading']),
    downLoad(data) {
      fetchGetDown("hcm/hcmReport/downloadReportExamine", data, "举报信息审核");
    },
    loadData() {
      console.log(123123123)
      this.changenormaltableLoading(true)
      // this.pagination.current = 1;
      // this.pagination.pageSize = 10;
      this.getReportExamine();

    },
    getReportExamine() {
      let other = this.creditSearchData;
      let data = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.size,
        type: this.activeName === "first" ? null : 3,
        ...other
      };
      fetchGet("/hcm/hcmReport/getReportExamine", data).then(res => {
         this.changenormaltableLoading(false)
        if (res.status === "10000") {
          res.data.content.map(item => {
            item.status = this.activeName === "first" ? 0 : 10;
          });
          this.tableData = res.data.content;
          this.totalPage = res.data.totalElements;
          this.$emit("change", this.totalPage);
        }
      }).catch(()=>{
          this.changenormaltableLoading(false)
      })
    },
    showInfo() {
      this.$refs.checkInfo.showDrawer();
    }
  },
  destroyed() {
    this.changeCompleteShow();
  }
};
</script>
<style lang="scss">
@import "src/style/tableCommon";
</style>
